
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class JobSearchingComponent extends Vue {

  /* PROP */

  @Prop({default: 'Job title or keywords...'})
  private placeholder: string;

  /* INITIALIZATION */

  private search: string = '';

  constructor() {
    super();
  }
}
